"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _webexCore = require("@webex/webex-core");
var _uuid = _interopRequireDefault(require("uuid"));
var _constants = require("../constants");
var _members = _interopRequireDefault(require("../members"));
var _request = _interopRequireDefault(require("./request"));
var _events = _interopRequireDefault(require("./events"));
/*!
 * Copyright (c) 2015-2023 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * @class
 */
var Breakout = _webexCore.WebexPlugin.extend({
  idAttribute: 'sessionId',
  namespace: _constants.MEETINGS,
  breakoutRequest: _request.default,
  props: {
    active: ['boolean', false, false],
    // this session is active
    allowed: ['boolean', false, false],
    // allowed to join this session
    assigned: ['boolean', false, false],
    // assigned to this session, but not necessarily joined yet
    assignedCurrent: ['boolean', false, false],
    // assigned AND current session
    requested: ['boolean', false, false],
    // requested by the host to join this session
    current: ['boolean', false, false],
    // the current joined session
    name: 'string',
    sessionId: 'string',
    sessionType: 'string',
    groupId: 'string',
    url: 'string',
    // where to send requests to
    requestedLastModifiedTime: 'string'
  },
  derived: {
    isMain: {
      cache: false,
      // fix issue: sometimes the derived will not change even if the deps changed
      deps: ['sessionType'],
      /**
       * If the breakout has no name, assume it is the main session
       * @returns {boolean}
       */
      fn: function fn() {
        return this.sessionType === 'MAIN';
      }
    }
  },
  /**
   * initializer for the Breakout class
   * @returns {void}
   */
  initialize: function initialize() {
    // @ts-ignore
    this.breakoutRequest = new _request.default({
      webex: this.webex
    });
    this.breakoutRosterLocus = null;
  },
  /**
   * Joins the breakout session
   * @returns {Promise}
   */
  join: function join() {
    var _this = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var breakoutMoveId, deviceUrl, meetingId, meeting, result;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            breakoutMoveId = _uuid.default.v4();
            deviceUrl = _this.webex.internal.device.url;
            meetingId = _this.collection.parent.meetingId;
            meeting = _this.webex.meetings.getMeetingByType(_constants._ID_, meetingId);
            _events.default.onBreakoutMoveRequest({
              currentSession: _this,
              meeting: meeting,
              breakoutMoveId: breakoutMoveId
            },
            // @ts-ignore
            _this.webex.internal.newMetrics.submitClientEvent.bind(_this.webex.internal.newMetrics));
            _context.next = 7;
            return _this.request({
              method: _constants.HTTP_VERBS.POST,
              uri: "".concat(_this.url, "/move"),
              body: {
                breakoutMoveId: breakoutMoveId,
                deviceUrl: deviceUrl,
                groupId: _this.groupId,
                sessionId: _this.sessionId
              }
            });
          case 7:
            result = _context.sent;
            _events.default.onBreakoutMoveResponse({
              currentSession: _this,
              meeting: meeting,
              breakoutMoveId: breakoutMoveId
            },
            // @ts-ignore
            _this.webex.internal.newMetrics.submitClientEvent.bind(_this.webex.internal.newMetrics));
            return _context.abrupt("return", result);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  /**
   * Leaves the breakout session to return to the main session
   * @returns {Promise}
   * @throws {Error} if an attempt is made to leave the main session or if the main session cannot be found
   */
  leave: function leave() {
    if (this.isMain) {
      throw new Error('Cannot leave the main session');
    }
    var mainSession = this.parent.breakouts.filter(function (breakout) {
      return breakout.isMain;
    })[0];
    if (!mainSession) {
      throw new Error('Cannot leave, no main session found');
    }
    return mainSession.join();
  },
  /**
   * Sends a help request for the current breakout
   * @returns {Promise}
   */
  askForHelp: function askForHelp() {
    return this.request({
      method: _constants.HTTP_VERBS.POST,
      uri: "".concat(this.url, "/help"),
      body: {
        groupId: this.groupId,
        sessionId: this.sessionId
      }
    });
  },
  /**
   * inits the members object
   * @returns {void}
   */
  initMembers: function initMembers() {
    var meetingId = this.collection.parent.meetingId;
    var meeting = this.webex.meetings.getMeetingByType(_constants._ID_, meetingId);
    this.members = new _members.default({
      meeting: meeting
    }, {
      parent: this.webex
    });
  },
  /**
   * check sequence and determine whether to update the new roster or not
   * @param {Object} locus Locus object
   * @returns {Boolean}
   */
  isNeedHandleRoster: function isNeedHandleRoster(locus) {
    var _this$breakoutRosterL, _this$breakoutRosterL2, _this$breakoutRosterL3, _locus$sequence, _locus$sequence$entri;
    if (!((_this$breakoutRosterL = this.breakoutRosterLocus) !== null && _this$breakoutRosterL !== void 0 && (_this$breakoutRosterL2 = _this$breakoutRosterL.sequence) !== null && _this$breakoutRosterL2 !== void 0 && (_this$breakoutRosterL3 = _this$breakoutRosterL2.entries) !== null && _this$breakoutRosterL3 !== void 0 && _this$breakoutRosterL3.length) || !(locus !== null && locus !== void 0 && (_locus$sequence = locus.sequence) !== null && _locus$sequence !== void 0 && (_locus$sequence$entri = _locus$sequence.entries) !== null && _locus$sequence$entri !== void 0 && _locus$sequence$entri.length)) {
      return true;
    }
    var prevSequence = this.breakoutRosterLocus.sequence.entries[0];
    var currentSequence = locus.sequence.entries[0];
    return currentSequence > prevSequence;
  },
  /**
   * Parses the participants from the locus object
   * @param {Object} locus Locus object
   * @returns {void}
   */
  parseRoster: function parseRoster(locus) {
    if (!this.members) {
      this.initMembers();
    }
    if (!this.isNeedHandleRoster(locus)) {
      return;
    }
    this.breakoutRosterLocus = locus;
    this.members.locusParticipantsUpdate(locus);
  },
  /**
   * Broadcast message to this breakout session's participants
   * @param {String} message
   * @param {Object} options
   * @returns {Promise}
   */
  broadcast: function broadcast(message, options) {
    return this.breakoutRequest.broadcast({
      url: this.url,
      message: message,
      options: options,
      groupId: this.groupId,
      sessionId: this.sessionId
    });
  },
  version: "3.7.0-web-workers-keepalive.1"
});
var _default = exports.default = Breakout;
//# sourceMappingURL=breakout.js.map
